export class JWTPayload {
  email: string;
  igg: string;

  constructor(token: JWTPayload) {
    this.email = token.email;
    this.igg = token.igg;
  }
}
